import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { Link as LinkOriginal } from 'Styles/links';
import breakpoint from 'Styles/breakpoints';
import ContentCardOriginal from '../../../ContentCard/ContentCard';
import { Copy } from '../../../ContentCard/ContentCard.styled';

const responsiveSpace = (property, largeValue, xLargeValue) => `
  ${property}: ${largeValue};
  ${breakpoint('xlarge')} {
    ${property}: ${xLargeValue};
  }
`;

export const NavFlyout = styled.div`
  &.flyout-container-enter {
    opacity: 0;
  }

  &.flyout-container-enter-active {
    opacity: 1;
    transition: opacity 200ms cubic-bezier(0, 0.5, 0.5, 1);
  }

  &.flyout-container-exit {
    opacity: 1;
  }
  &.flyout-container-exit-active {
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0, 0.5, 0.5, 1);
  }
`;

export const Backdrop = styled.div`
  background: rgba(29, 29, 29, 0.75);
  height: 100vh;
  z-index: 997;
`;

export const LayoutContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: var(--background);
  position: absolute;
  max-height: calc(100vh - ${(props) => props.positionFromTop}px);
  width: 100%;
  overflow: auto;
  z-index: 998;
`;

export const Layout = styled.div`
  display: flex;
  max-width: 1264px;
  padding-top: 16px;
  padding-bottom: 24px;
  padding-left: 48px;
  padding-right: 48px;
  width: 100%;
  justify-content: center;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 160px;
  width: 160px;
  box-sizing: content-box;
  border-right: 1px solid var(--border);
  ${responsiveSpace('padding-right', '16px', '32px')};

  ${switchProp('$flyoutAnimationStyle', {
    piano: `
      opacity: 0;
      transform: translateY(8px);
      animation: piano-column-in 800ms cubic-bezier(0, 0.5, 0.5, 1) forwards;

      @keyframes piano-column-in {
        from {
          opacity: 0;
          transform: translateY(8px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
    fade: `
      opacity: 0;
      animation: fade-in 200ms cubic-bezier(0, 0.5, 0.5, 1) forwards;

      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `
  })};
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  ${responsiveSpace('gap', '16px', '32px')};
  ${({ hasLeftContainer }) =>
    hasLeftContainer &&
    `
      ${responsiveSpace('padding-left', '16px', '32px')};
    `}
`;

export const NavFlyoutColumn = styled.div`
  width: 136px;
  min-width: 136px;
  ${({ hasCard }) =>
    hasCard &&
    css`
      display: flex;
      flex-direction: column;
      flex: 1 2 100%;
      min-width: 160px;
      max-width: 304px;
      ${responsiveSpace('gap', '16px', '32px')};
    `}

  ${switchProp('$flyoutAnimationStyle', {
    piano: css`
      opacity: 0;
      transform: translateY(8px);

      ${({ $colIndex }) =>
        `
          animation: piano-column-in-${$colIndex} 600ms cubic-bezier(0, 0.5, 0.5, 1) ${
          $colIndex * 75
        }ms forwards;

          @keyframes piano-column-in-${$colIndex} {
            from {
              opacity: 0;
              transform: translateY(8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          } 
        `}
    `,
    fade: `
      animation: fade-in 200ms cubic-bezier(0, 0.5, 0.5, 1) forwards;

      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `
  })};
`;

export const Link = styled(LinkOriginal)`
  ${({ color }) => color && `color: ${color}`}
`;

export const CardContainer = styled.div`
  display: grid;
  width: 100%;
  ${responsiveSpace('gap', '16px', '32px')};
  ${({ numColumns }) => css`
    grid-template-columns: repeat(${numColumns}, 1fr);
    grid-auto-rows: max-content;
  `}

  &.card-transition-appear {
    opacity: 0;
  }

  &.card-transition-appear-active {
    opacity: 1;
    /** 400ms total duration with 200ms delay **/
    transition: opacity 400ms cubic-bezier(0, 0.5, 0.5, 1);
  }

  &.card-transition-exit {
    opacity: 1;
  }
  &.card-transition-exit-active {
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0, 0.5, 0.5, 1);
  }
`;

export const ContentCard = styled(ContentCardOriginal)`
  grid-column: span 1;
  min-width: 160px;
  ${Copy} {
    font-family: var(--accent-font);
    padding: 12px 0 0;
  }
  h3 {
    font-family: var(--accent-font);
    font-size: 16px;
    font-weight: 400;
  }
  img {
    border-radius: 0;
  }
`;
